<template>
  <div>
    <div v-if="errorAutoAssign && errorAutoAssign.length">
      <b-alert :show="errorAutoAssign && errorAutoAssign.length ? true : false" variant="danger">
        <div v-if="Array.isArray(errorAutoAssign)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in errorAutoAssign" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="errorAutoAssign || '&nbsp;'"></div>
        </div>
      </b-alert>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <QuickSearchHeader @search="search" />
      <div></div>
      <div class="d-flex align-items-center justify-content-end">
        <div v-if="showAutoAssignFunction && false">
          <base-button id="InsuranceCompany-add-btn" variant="secondary" :cus_style="exportBtnStyle"
            :class="['mt-1 px-4']" @click="showAutoAssignModal" :disabled="loadingAutoAssign || disableAutoAssign">
            <div v-if="loadingAutoAssign">
              <b-spinner style="width: 1rem; height: 1rem"></b-spinner>
            </div>
            <div v-else>
              <img src="@/assets/images/icons/add-icon.svg" alt="add-icon" class="mx-1" />
            </div>
            <span>
              {{ $t("auto-assign") }}
            </span>
          </base-button>
        </div>
        <div>
          <base-button id="InsuranceCompany-add-btn" variant="secondary" :cus_style="exportBtnStyle" 
       
            :class="['mt-1 px-4']" @click="download">
            {{ $t("export") }}
            <img class="export-icon" src="@/assets/images/icons/export-icon.svg" />
          </base-button>
        </div>
        <b-sidebar id="sidebar-backdrop" bg-variant="white" backdrop-variant="transparent" backdrop :right="!isLangRtl"
          shadow width="350px">
          <filterSideBar :payload="search_payload" @filter-data="filterData" @reset-data="resetData"
            :garageOptions="garageOptions" @update-payload="setSearchValue" />
        </b-sidebar>
      </div>
    </div>
    <b-tabs class="custom-nav-tabs" v-model="tabIndex" content-class="mb-3">
      <b-tab :title="$t('all')"> </b-tab>
      <b-tab :title="$t('updated')"> </b-tab>
      <b-tab :title="$t('upcoming')"> </b-tab>
      <b-tab :title="$t('canceled')"> </b-tab>
    </b-tabs>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="result">{{ total }} {{ $t("results") }}</h5>
      <div @mouseenter="mouseenter" @mouseleave="mouseleave">
        <base-button variant="secondary" class="mx-2 filter__btn" :disabled="loading" cus_style="padding:10px"
          v-b-toggle.sidebar-backdrop>
          <img :src="filter_btn_hovered
            ? require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
            : require(`@/assets/images/icons/funnel-simple-bold-svgrepo-com.png`)
            " alt="funnel-simple" />
        </base-button>
      </div>
    </div>
    <div v-if="tabIndex !== 3" class="sub-status-list mb-3 d-flex align-items-between flex-wrap">
      <div v-for="(sub_status, index) in sub_status_enum" :key="index" :class="[
        'sub-status',
        'me-3',
        { selected: search_payload.sub_status === sub_status.value },
      ]" @click="selectSubStatus(sub_status.value)">
        <div class="icon me-2" :style="`background: ${sub_status.background}`">
          <img :src="sub_status.icon" alt="icon" />
        </div>
        <div>
          {{ $t(sub_status.label) }}
        </div>
      </div>
    </div>
    <base-spinner v-if="loading" />
    <div v-else>
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <data-table :items="items" :total="total" :perPage="perPage" :page="page" :sortBy="sortBy" :sortDesc="sortOrder"
        @change-page="changePage" @row-clicked="rowClicked" @sort-changed="handleSort" />
    </div>
    <b-sidebar :visible="show_detail" id="trip-detail-sidebar-backdrop" bg-variant="white" backdrop :right="!isLangRtl"
      shadow width="70%" @hidden="hidden">
      <TripDetail v-if="show_detail" :id="trip_id" @update-flag="updateFlag" @change-tab="changeTab"
        @refetchData="getData" />
    </b-sidebar>
    <base-alert modalId="auto-assign-driver-warning-modal" icon="popup-warning-icon" :title="$t('auto-assign-mes')"
      :description="$t('auto-assign-confirmation')">
      <template #buttons>
        <base-button id="auto-assign-driver-warning-modal-submit-btn" variant="primary" @click="autoAssign"
          class="col-3 mb-3">
          {{ $t("yes") }}
        </base-button>
        <base-button id="auto-assign-driver-modal-cancel-btn" variant="secondary" @click="hideModal" class="col-3 mb-3">
          {{ $t("no") }}
        </base-button>
      </template>
    </base-alert>
    <SuccessModal />
  </div>
</template>

<script>
import filterSideBar from "./filterSideBar";
import DataTable from "./dataTable.vue";
import TripDetail from "./detail.vue";
import TripService from "@/services/trip.service";
import moment from "moment";
import SuccessModal from "./SuccessModal";
import QuickSearchHeader from "./quickSearch.vue";
import BranchService from "@/services/branch.service";
import { state } from "@/socket";

export default {
  components: {
    filterSideBar,
    DataTable,
    TripDetail,
    SuccessModal,
    QuickSearchHeader,
  },
  data() {
    return {
      loading: false,
      loadingAutoAssign: false,
      allGarages: [],
      garageOptions: [],
      error: null,
      errorAutoAssign: null,
      exportBtnStyle: `padding:6px;font-weight: 600;`,
      filter_btn_hovered: false,
      perPage: 15,
      page: 1,
      assignList: [],
      search_payload: {
        _id: null,
        selected_journey_status: [],
        beneficiaryNationalId: null,
        iqamaNumberEntry: null,
        waterSource: null,
        tgaNumber: null,
        blanketOrderId: null,
        zone: null,
        garage: null,
        start_date: null,
        start_date_end: null,
        end_date: null,
        end_date_to: null,
        start_time: null,
        end_time: null,
        branch: [],
        sub_status: null,
        plateNumber: null,
        blanketOrderDescription: "",
        contractorName: null,
        client: null
      },
      quick_search_key: null,
      quick_search_value: null,
      items: [],
      total: 0,
      show_detail: null,
      trip_id: null,
      tabIndex: 0,
      showAutoAssignBtn: false,
      sub_status_enum: [
        {
          label: "all-updates",
          value: null,
          icon: require(`@/assets/images/icons/file-1-icon.svg`),
          background: "var(--color-64)",
        },
        {
          label: "reviewed",
          value: "Reviewed",
          icon: require(`@/assets/images/icons/arrow-refresh-icon.svg`),
          background: "var(--color-92)",
        },
        {
          label: "approval-needed",
          value: "Approval-Needed",
          icon: require(`@/assets/images/icons/clock-1-icon.svg`),
          background: "var(--color-125)",
        },
        {
          label: "action-required",
          value: "Action-Required",
          icon: require(`@/assets/images/icons/alert-triangle-icon.svg`),
          background: "var(--color-124)",
        },
        {
          label: "archived",
          value: "Archived",
          icon: require(`@/assets/images/icons/archive-icon.svg`),
          background: "var(--color-131)",
        },
      ],
      sortOrder: true,
      sortBy: "scheduledStartTime",
      garageOptions: [{ value: null, text: "no-options-available" }],
    };
  },
  methods: {
    async getGarageOptions(branchIds) {
      const requests = branchIds.map(branchId =>
        BranchService.get(`${branchId}/garages`, {
          active: true,
          select: "_id,name,arabicName",
          limit: 10000000000000,
        }).then(res => ({ branchId, items: res.items }))
      );

      const responses = await Promise.all(requests);

      responses.forEach(({ branchId, items }) => {
        items.forEach(g => {
          const exists = this.allGarages.find(x => x.value === g._id);
          if (!exists) {
            this.allGarages.push({
              value: g._id,
              text: this.isLangRtl ? g.arabicName : g.name,
              branchId,
            });
          }
        });
      });

      this.syncGarageOptions();
    },
    syncGarageOptions() {
      this.garage_optoins = [
        { value: null, text: "select-an-option" },
        ...this.allGarages,
      ];
    },

    quickSearch() {
      this.page = 1;
      this.getData();
    },
    search(key, value) {
      this.quick_search_key = key;
      this.quick_search_value = value;
      this.getData();
    },
    selectSubStatus(sub_status) {
      this.search_payload.sub_status = sub_status;
      this.quickSearch();
    },
    changeTab(tab) {
      this.selectSubStatus(tab);
    },
    updateFlag(id) {
      this.items = this.items?.map((item) => {
        if (item._id === id) item["_rowVariant"] = null;
        return item;
      });
    },
    rowClicked(item) {
      this.show_detail = true;
      this.trip_id = item?._id;
    },
    hidden() {
      this.show_detail = false;
      this.trip_id = null;
    },
    setSearchValue(val, field) {
      this.search_payload[field] = val;
    },
    mouseenter() {
      this.filter_btn_hovered = true;
    },
    mouseleave() {
      this.filter_btn_hovered = false;
    },
    changePage(val) {
      this.page = val;
      this.getData();
    },
    filterData(resetData) {
      this.page = 1;
      this.getData(resetData);
    },
    resetData() {
      this.showAutoAssignBtn = false;
      this.search_payload = {
        _id: null,
        selected_journey_status: [],
        beneficiaryNationalId: null,
        iqamaNumberEntry: null,
        waterSource: null,
        tgaNumber: null,
        blanketOrderId: null,
        zone: null,
        garage: null,
        start_date: null,
        start_date_end: null,
        end_date: null,
        end_date_to: null,
        start_time: null,
        end_time: null,
        branch: [],
        sub_status: null,
        plateNumber: null,
        blanketOrderDescription: "",  
        contractorName: null,        
        client: null                   
      };
      this.filterData("resetData");
    },
    buildTripQueryParams(notifyFilterApplied = () => { }) {
      const params = new URLSearchParams();

      if (this.quick_search_key && this.quick_search_value) {
        notifyFilterApplied();
        if (
          this.quick_search_key === "client" ||
          this.quick_search_key === "branch" ||
          this.quick_search_key === "operationalID" ||
          this.quick_search_key === "employeeID"
        ) {
          params.append(this.quick_search_key, this.quick_search_value);
        } else {
          if (this.quick_search_key === "referenceNumber") {
            let valueAfterHash;

            if (this.quick_search_value.includes("#")) {
              const valueParts = this.quick_search_value.split("#");
              valueAfterHash = valueParts[1] || "";
            } else {
              valueAfterHash = this.quick_search_value;
            }
            params.append(this.quick_search_key, "*" + valueAfterHash + "*");
          } else {
            params.append(
              this.quick_search_key,
              "*" + this.quick_search_value + "*"
            );
          }
        }
      }

      if (this.search_payload) {
        if (this.search_payload.client) {
          params.append("client", this.search_payload.client);
        }

        if (this.search_payload._id) {
          params.append("_id", "*" + this.search_payload._id + "*");
          notifyFilterApplied();
        }
        if (this.search_payload.blanketOrderDescription) {
          params.append(
            "blanketOrderDescription",
            this.search_payload.blanketOrderDescription
          );
        }

        if (this.search_payload.blanketOrderId) {
          params.append(
            "blanketOrder",
            this.search_payload.blanketOrderId
          );
          notifyFilterApplied();
        }

        if (this.search_payload.beneficiaryNationalId) {
          params.append(
            "externalReferenceId",
            this.search_payload.beneficiaryNationalId
          );
          notifyFilterApplied();
        }

        if (this.search_payload.zone) {
          params.append("zone", this.search_payload.zone);
          notifyFilterApplied();
        }

        if (this.search_payload.selected_journey_status.length) {
          params.append(
            "status",
            "in:[" +
            this.search_payload.selected_journey_status?.map(
              (each) => each.value
            ) +
            "]"
          );
          notifyFilterApplied();
        }

        if (this.search_payload.iqamaNumberEntry) {
          params.append(
            "driverIqamaEntryNumber",
            this.search_payload.iqamaNumberEntry
          );
          notifyFilterApplied();
        }

        if (this.search_payload.waterSource) {
          params.append(
            "waterSource",
            this.search_payload.waterSource
          );
          notifyFilterApplied();
        }

        if (this.search_payload.tgaNumber) {
          params.append(
            "tgaNumber",
            this.search_payload.tgaNumber
          );
          notifyFilterApplied();
        }

        if (this.search_payload?.branch?.length) {
          params.append(
            "branch",
            `in:[${this.search_payload.branch.map(b => b.value).join(",")}]`
          );
        } else {
          const userBranch = this.$store.getters["enums/user_info"].branch;

          if (
            Array.isArray(userBranch)
              ? userBranch.length > 0
              : userBranch
          ) {
            params.append(
              "branch",
              Array.isArray(userBranch)
                ? `in:[${userBranch.join(",")}]`
                : userBranch
            );
          }
        }

        if (this.search_payload.garage?.length) {
          params.append(
            "garage",
            "in:[" + this.search_payload.garage.map(g => g.value) + "]"
          );
        }


        if (
          this.search_payload.start_date ||
          this.search_payload.start_date_end
        ) {
          notifyFilterApplied();
          if (this.search_payload.start_time) {
            const parts = this.search_payload.start_time.split(":");
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            if (d) {
              params.append("scheduledStartTime", `gte:${d}`);
            }

            if (e) {
              params.append("scheduledStartTime", `lte:${e}`);
            }
          }
          if (
            this.search_payload.start_date &&
            this.search_payload.start_date_end
          ) {
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            params.append("scheduledStartDate", `gte:${d}`);
            params.append("scheduledStartDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.start_date ||
              this.search_payload.start_date_end
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledStartDate", `gte:${d}`);
          }
        }

        if (this.search_payload.end_date || this.search_payload.end_date_to) {
          notifyFilterApplied();
          if (this.search_payload.end_time) {
            const parts = this.search_payload.end_time.split(":");
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            if (d) {
              params.append("scheduledEndTime", `gte:${d}`);
            }

            if (e) {
              params.append("scheduledEndTime", `lte:${e}`);
            }
          }
          if (this.search_payload.end_date && this.search_payload.end_date_to) {
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
            params.append("scheduledEndDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.end_date || this.search_payload.end_date_to
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
          }
        }

        if (this.search_payload.sub_status) {
          notifyFilterApplied();
          params.append("subStatus", this.search_payload.sub_status);
        }
      }
      if (this.search_payload.plateNumber) {
        params.append(
          "plateNumber",
          this.search_payload.plateNumber
        );
        notifyFilterApplied();
      }
      if (
        this.$store.getters["enums/user_info"].clientID ||
        this.$route?.query?.clientID
      ) {
        params.append(
          "client",
          this.$store.getters["enums/user_info"].clientID
            ? this.$store.getters["enums/user_info"].clientID
            : this.$route?.query?.clientID
              ? this.$route?.query?.clientID
              : null
        );
      }

      return params;
    },
    async getData(resetData) {
      this.loading = true;
      this.error = null;
      this.errorAutoAssign = null;
      this.total = 0;
      this.items = [];

      let params = this.buildTripQueryParams(() => this.showAutoAssign());

      params.append("page", this.page || 1);
      params.append("limit", this.perPage);
      params.append("sort", this.sortBy);
      params.append(
        "select",
        `
  _id,
  status,
  subStatus,
  viewed,
  isDeadhead,

  service._id,
  service.name,
  service.arabicName,

  branch._id,
  branch.name,
  branch.arabicName,

  startLocation.name,
  endLocation.name,

  scheduledStartDate,
  scheduledStartTime,
  scheduledEndDate,
  scheduledEndTime,

  mainDriver.employeeID,
  mainDriver.idNumber,
  mainDriver.mobileNumber,

  vehicle.tgaNumber,
  vehicle.plateNumber,

  beneficiary.externalReferenceId,

  waterSource._id,
  waterSource.name,
  waterSource.arabicName,

  reservation._id,
  reservation.referenceNumber,

  reservation.blanketOrder._id,
  reservation.blanketOrder.orderCode,

  reservation.client._id,
  reservation.client.name,
  reservation.client.arabicName,

  reservation.category._id,
  reservation.category.name,
  reservation.category.arabicName,

  reservation.zone._id,
  reservation.zone.name,
  reservation.zone.arabicName,
  garage._id,
  garage.name,
  garage.arabicName,
  zone._id,
  zone.name,
  zone.arabicName,
  contractorName,
  blanketOrderDescription,
  actualStartTime,
  actualEndTime
  `
      );
      ;

      try {
        let res;

        if (this.tabIndex === 0) res = await TripService.search(params);
        else if (this.tabIndex === 1)
          res = await TripService.get("updated", params);
        else if (this.tabIndex === 2)
          res = await TripService.get("upcomming", params);
        else if (this.tabIndex === 3)
          res = await TripService.get("cancelled", params);
        this.total = res?.total;
        this.items = res?.items?.map((each) => {
          console.log("actualEndTime from API:", res?.actualEndTime);

          const isReservation = !!each?.reservation;
          return {
            _rowVariant: each?.isDeadhead
              ? "danger"
              : each?.subStatus === "Approval-Needed"
                ? "success"
                : null,
            reservation: each?.reservation?._id || "---",
            client: isReservation
              ? this.isLangRtl
                ? each?.reservation?.client?.arabicName
                : each?.reservation?.client?.name
              : this.isLangRtl
                ? each?.contract?.client?.arabicName
                : each?.contract?.client?.name,
            reference_number: isReservation
              ? each?.reservation?.referenceNumber
              : each?.contract?.referenceNumber || "---",
            service: this.isLangRtl
              ? each?.service?.arabicName
              : each?.service?.name,
            start: each?.startLocation?.name,
            end: each?.endLocation?.name,
            _id: each._id,
            actualStartTime: moment.utc(each?.actualStartTime).locale("en")
              .local()
              .format("HH:mm"),
            actualEndTime: each?.actualEndTime
              ? moment.utc(each.actualEndTime).locale("en").local().format("HH:mm")
              : "---",
            scheduledStartDate: moment.utc(each.scheduledStartDate)
              .locale("en")
              .local()
              .format("DD-MM-YYYY"),
            scheduledStartTime: moment.utc(each.scheduledStartTime)
              .locale("en")
              .local()
              .format("HH:mm"),
            scheduledEndDate: each?.scheduledEndDate ? moment.utc(each.scheduledEndDate)
              .locale("en")
              .local()
              .format("DD-MM-YYYY") : "---",
            scheduledEndTime: each?.scheduledEndTime ? moment.utc(each.scheduledEndTime)
              .locale("en")
              .local()
              .format("HH:mm") : "---",
            driver: each?.mainDriver?.idNumber || "---",
            driverMobileNumber: each?.mainDriver?.mobileNumber || "---",
            vehicle: each?.vehicle?.plateNumber || "---",
            status: each.status,
            branch: this.isLangRtl
              ? each?.branch?.arabicName
              : each?.branch?.name,
            sub_status: each.subStatus,
            blanketOrderId: each?.reservation?.blanketOrder?.orderCode || "---",
            beneficiaryNationalId: each?.beneficiary?.externalReferenceId || "---",
            zone: this.isLangRtl
              ? each?.zone?.arabicName || "---"
              : each?.zone?.name || "---",
            garage: this.isLangRtl
              ? each?.garage?.arabicName || "---"
              : each?.garage?.name || "---",
            waterSource: this.isLangRtl
              ? each?.waterSource?.arabicName || "---"
              : each?.waterSource?.name || "---",
          };

        });
      } catch ({ message }) {
        this.error = message;
      } finally {
        this.loading = false;
      }
    },
    buildDownloadParams() {
      return this.buildTripQueryParams();
    },
    downloadTrips() {
      const downloadParams = this.buildDownloadParams();
      const tabSlugs = ["", "updated", "upcomming", "cancelled"];
      const slug = tabSlugs[this.tabIndex] || "";

      this.error = null;
      // this.loadingExport = true;
      this.$store
        .dispatch("enums/GET_TRIPS_FILE", { params: downloadParams, slug })
        .then(() => {
          this.$bvModal.show("trips-export-modal");
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loadingExport = false;
        });
    },
    download() {
      this.downloadTrips();
    },
    autoAssign() {
      this.errorAutoAssign = null;
      this.loadingAutoAssign = true;
      this.hideModal();
      let params = new URLSearchParams();
      params.append("isDeadhead", false);
      if (this.quick_search_key && this.quick_search_value) {
        if (
          this.quick_search_key === "client" ||
          this.quick_search_key === "branch" ||
          this.quick_search_key === "operationalID" ||
          this.quick_search_key === "employeeID"
        ) {
          params.append(this.quick_search_key, this.quick_search_value);
        } else {
          if (this.quick_search_key === "referenceNumber") {
            let valueAfterHash;

            if (this.quick_search_value.includes("#")) {
              const valueParts = this.quick_search_value.split("#");
              valueAfterHash = valueParts[1] || "";
            } else {
              valueAfterHash = this.quick_search_value;
            }
            params.append(this.quick_search_key, "*" + valueAfterHash + "*");
          } else {
            params.append(
              this.quick_search_key,
              "*" + this.quick_search_value + "*"
            );
          }
        }
      }
      if (this.search_payload) {
        if (this.search_payload._id) {
          params.append("_id", "*" + this.search_payload._id + "*");
        }

        if (this.search_payload.blanketOrderId) {
          params.append(
            "blanketOrder",
            this.search_payload.blanketOrderId
          );
        }


        if (this.search_payload.beneficiaryNationalId) {
          params.append(
            "externalReferenceId",
            this.search_payload.beneficiaryNationalId
          );
        }

        if (this.search_payload.iqamaNumberEntry) {
          params.append(
            "iqamaNumberEntry",
            this.search_payload.iqamaNumberEntry
          );
        }

        if (this.search_payload.waterSource) {
          params.append(
            "waterSource",
            this.search_payload.waterSource
          );
        }

        if (this.search_payload.tgaNumber) {
          params.append(
            "tgaNumber",
            this.search_payload.tgaNumber
          );
        }

        if (this.search_payload.selected_journey_status.length) {
          params.append(
            "status",
            "in:[" +
            this.search_payload.selected_journey_status?.map(
              (each) => each.value
            ) +
            "]"
          );
        }

        if (this.$store.getters["enums/user_info"].branch) {
          params.append(
            "branch",
            this.$store.getters["enums/user_info"].branch
          );
        } else if (this.search_payload?.branch?.length) {
          params.append(
            "branch",
            "in:[" +
            this.search_payload?.branch?.map((each) => each.value) +
            "]"
          );
        }

        if (
          this.search_payload.start_date ||
          this.search_payload.start_date_end
        ) {
          if (this.search_payload.start_time) {
            const parts = this.search_payload.start_time.split(":");
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            params.append("scheduledStartTime", `gte:${d}`);
            params.append("scheduledStartTime", `lte:${e}`);
          }
          if (
            this.search_payload.start_date &&
            this.search_payload.start_date_end
          ) {
            let d = moment(this.search_payload.start_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.start_date_end)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            params.append("scheduledStartDate", `gte:${d}`);
            params.append("scheduledStartDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.start_date ||
              this.search_payload.start_date_end
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledStartDate", `${d}`);
          }
        }

        if (this.search_payload.end_date || this.search_payload.end_date_to) {
          if (this.search_payload.end_time) {
            const parts = this.search_payload.end_time.split(":");
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .hour(parseInt(parts[0], 10))
              .minute(parseInt(parts[1], 10))
              .second(parseInt(parts[2], 10))
              .toISOString();

            params.append("scheduledEndTime", `gte:${d}`);
            params.append("scheduledEndTime", `lte:${e}`);
          }
          if (this.search_payload.end_date && this.search_payload.end_date_to) {
            let d = moment(this.search_payload.end_date)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();
            let e = moment(this.search_payload.end_date_to)
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `gte:${d}`);
            params.append("scheduledEndDate", `lte:${e}`);
          } else {
            let d = moment(
              this.search_payload.end_date || this.search_payload.end_date_to
            )
              .locale("en")
              .utc()
              .add(3, "hours")
              .toISOString();

            params.append("scheduledEndDate", `${d}`);
          }
        }

        if (this.search_payload.sub_status) {
          params.append("subStatus", this.search_payload.sub_status);
        }
      }
      TripService.post(
        {},
        "auto-assign-trips-with-status-booking-unassigned",
        params
      )
        .then((res) => {

          this.loadingAutoAssign = false;
          this.assignList = res;
          if (res !== 0) {
            this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("auto-assign-info"),
              variant: "info",
              title: this.$t("assign"),
              duration: 10000,
              noCloseButton: true,
              noAutoHide: false,
            });
          } else {
            this.$store.dispatch("enums/SHOW_TOASTER_POP", {
              message: this.$t("auto-assign-warning"),
              variant: "warning",
              title: this.$t("assign"),
              duration: 10000,
              noCloseButton: true,
              noAutoHide: false,
            });
            this.assignList = [];
          }
        })
        .catch((err) => {
          this.loadingAutoAssign = false;
          this.errorAutoAssign = err.message;
        });
    },
    showAutoAssign() {
      this.showAutoAssignBtn = true;
    },
    showAutoAssignModal() {
      this.$bvModal.show("auto-assign-driver-warning-modal");
    },
    hideModal() {
      this.$bvModal.hide("auto-assign-driver-warning-modal");
    },
    handleSort({ sortBy, sortDesc }) {
      this.sortBy = sortDesc ? `-${sortBy}` : sortBy;
      console.log("SORT BEING SENT:", this.sortBy);
this.sortOrder = sortDesc;
this.getData();
    },
  },
  computed: {
    showAutoAssignFunction() {
      const checkStatus = this.items?.some(
        (item) => item.status === "Booking-Un-Assigned"
      );
      return this.showAutoAssignBtn && checkStatus;
    },
    auto_assign_trip() {
      return state.auto_assign_trip;
    },
    disableAutoAssign() {
      return this.assignList?.length !== 0;
    },
  },
  watch: {
    $route(val) {
      if (val?.query?.id) {
        this.show_detail = true;
        this.trip_id = val?.query?.id;
      }
    },
    tabIndex: {
      handler() {
        this.selectSubStatus(null);
      },
      immediate: true,
    },
    auto_assign_trip(val) {
      if (val && val?.userID === this.$store.getters["enums/user_info"].userID)
        this.assignList = [];
      this.getData();
    },
    "search_payload.branch": {
      deep: true,
      async handler(branches) {
        const branchArray = Array.isArray(branches) ? branches : [];

        // Case 1: All branches removed
        if (branchArray.length === 0) {
          // 1. Reset dropdown options to show all possible garages again
          this.garageOptions = [
            { value: null, text: this.$t("select-an-option") },
            ...this.$store.getters["enums/garage_enums"],
          ];

          // 2. CRITICAL FIX: Clear the garage selection so it doesn't stay filtered
          this.search_payload.garage = [];
          return;
        }

        // Case 2: Some branches remain
        try {
          const branchIds = branchArray.map(b => b.value ?? b);
          const responses = await Promise.all(
            branchIds.map(branchId =>
              BranchService.get(`${branchId}/garages`, {
                active: true,
                select: "_id,name,arabicName",
                limit: 1000,
              })
            )
          );

          const garageMap = new Map();
          responses.forEach(res => {
            if (res.items) {
              res.items.forEach(g => {
                garageMap.set(g._id, {
                  value: g._id,
                  text: this.isLangRtl ? g.arabicName : g.name,
                });
              });
            }
          });

          const newOptions = Array.from(garageMap.values());
          this.garageOptions = [
            { value: null, text: this.$t("select-an-option") },
            ...newOptions,
          ];

          // Filter existing selection to keep only garages belonging to remaining branches
          if (this.search_payload.garage && this.search_payload.garage.length) {
            const validGarageIds = new Set(newOptions.map(opt => opt.value));
            this.search_payload.garage = this.search_payload.garage.filter(selectedG =>
              validGarageIds.has(selectedG.value ?? selectedG)
            );
          }
        } catch (err) {
          console.error("Error fetching garages:", err);
        }
      },
    },

  },
  mounted() {
    this.tabIndex = 0;
    if (this.$route?.query?.id) {
      this.show_detail = true;
      this.trip_id = this.$route?.query?.id;
    }
  },

  created() {
    this.$store.dispatch("enums/GET_BRANCH_ENUMS");
    this.$store.dispatch("enums/GET_CLIENT_ENUMS");
    this.$store.dispatch("enums/GET_ZONE_ENUMS");
    this.$store.dispatch("enums/GET_GARAGE_ENUMS", {}).then(() => {
      this.garageOptions = this.$store.getters["enums/garage_enums"];
    });

  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/manageTrips.json"),
      ar: require("@/services/i18n/locales/ar/manageTrips.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.export-icon {
  margin-inline-start: 10px;
  margin-inline-end: -3px;
}
</style>

<style lang="scss">
.sub-status-list {
  .sub-status {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 0.375rem;
    border: 1px solid var(--color-84);
    background: var(--color-01);
    padding: 0.5rem;
    color: var(--color-61);
    font-size: 0.875rem;

    &.selected {
      background: var(--color-84);
      font-weight: 700;
    }

    .icon {
      display: flex;
      padding: 0.4375rem;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
    }
  }
}
</style>